// Centralized client-side logger. In production builds (NODE_ENV === "production")
// these are no-ops so we don't leak stack traces or internal error details into
// the browser console for end users. In development they pass through to the
// real console for live debugging.

const isProduction = process.env.NODE_ENV === "production";

export function logError(...args) {
  if (!isProduction) {
    console.error(...args);
  }
}

export function logWarn(...args) {
  if (!isProduction) {
    console.warn(...args);
  }
}

export function logInfo(...args) {
  if (!isProduction) {
    console.info(...args);
  }
}
